<div class="flex flex-col gap-4">
  <div class="flex items-start gap-4">
    <div class="flex flex-col gap-4 h-full justify-start flex-1 min-w-0">
      <div class="flex items-center gap-4">
        <div class="bg-white rounded-lg">
          <p-button [label]="'Back'"
                    [severity]="'secondary'"
                    [outlined]="true"
                    [icon]="'fa fa-chevron-left'"
                    (onClick)="goBack()"
          ></p-button>
        </div>

        <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">
          {{ 'Travel Allowance Acquittal Approval for ' + taSubmission()?.taNumber }}
        </div>

        <div class="flex gap-1 items-center">
          @if (travellersLength() > 1) {
            <i class="fa-solid fa-users"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name + ' (+' + (taSubmission()!.travellerCount! - 1) + ')'}}</div>
          } @else {
            <i class="fa-solid fa-user"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name}}</div>
          }
        </div>
      </div>

        <div class="p-1">
          <ta-toast title="Overpayment for TA has occurred."
                    body="Due to a change in the value of the TA during acquittal, the prepayment exceeds the value of the TA."
                    severity="info"
                    [closable]="false"
                    [visible]="showOverPaidWarning()"
          ></ta-toast>
        </div>

      <div class="justify-start text-text-color text-sm font-semibold font-['Inter'] leading-4">{{'Travel Date: ' + ((taSubmission()?.startDate | date: 'dd/MM/yy') ?? '-') }}</div>

      @if (acquittalApprovalRole() === 'primaryApprover') {
        @if (travellersLength() > 1) {
          <div class="justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-4">Please review the travel allowance details below and select one of the following actions.  Please note that you are approving acquittal for </span><span class="text-text-color text-sm font-bold font-['Inter'] leading-4">a group of staff</span><span class="text-text-color text-sm font-normal font-['Inter'] leading-4">.</span></div>
          <div class="justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">The breakdown of the acquittal value, per traveller, is as follows:</div>
        } @else {
          <div class="w-[594px] justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">Please review the travel allowance details below and select one of the following actions.</div>
        }
      } @else if (currentApproval()) {
        <div class="w-full lg:w-1/2 text-text-color text-sm font-normal font-['Inter'] leading-4">
          This TA is awaiting <span class="font-semibold">{{ currentApproval()?.stageLabel }}</span> approval.
        </div>
      }
      <!-- A view only user is told which stage the TA is waiting on above, and who by the approvals table below. -->

      <ta-approvals-table [taSubmission]="taSubmission()"
                          [contexts]="travelContexts"
                          heading="Travel Approvals"
      ></ta-approvals-table>

      <ta-approvals-table [taSubmission]="taSubmission()"
                          [contexts]="acquittalContexts"
                          [editable]="true"
                          heading="Required Acquittal Approvals"
      ></ta-approvals-table>
    </div>

    <div class="flex flex-col gap-2 items-end">
      <ta-cost-bubble title="Approved TA Value" [value]="originalTaValue()" severity="outlined"></ta-cost-bubble>
      <ta-cost-bubble title="Acquitted TA Value" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
      <ta-cost-bubble title="Change in TA Value" [value]="acquittedValueChange()" [severity]="acquittedValueChange() === 0 ? 'text' : 'outlined'" [signed]="true"></ta-cost-bubble>
      <ta-cost-bubble title="Finalisation Payment Due" [value]="finalisationPaymentDue()" severity="primary"></ta-cost-bubble>
      <div class="w-full h-[1px] bg-surface-200"></div>
      @if (isPrePaid()) {
        <ta-cost-bubble title="Prepayment Component" titleIcon="fa-regular fa-piggy-bank text-green-700" [value]="prepaymentComponent()" severity="success"></ta-cost-bubble>
        @if (overpaymentMade() > 0) {
          <ta-cost-bubble title="Overpayment Made" titleIcon="fa-regular fa-piggy-bank text-[#DC2626]" [value]="overpaymentMade()" severity="danger"></ta-cost-bubble>
        }
      }
      <ta-cost-bubble title="Day Trip Component" [value]="dayTripComponent()" severity="purple"></ta-cost-bubble>
<!--      <div class="h-2"></div>-->
<!--      <ta-audit-log-button [taSubmission]="taSubmission()"></ta-audit-log-button>-->
    </div>
  </div>

  @if (showPreAcquittalDayTripTable()) {
    <manage-ta-day-trip-payment-table [rows]="dayTripPaymentRows()"></manage-ta-day-trip-payment-table>
  }

  <itinerary-difference-comparison [showTravellerPortions]="!showPreAcquittalDayTripTable()"></itinerary-difference-comparison>

  @if (acquittalApprovalRole() === 'primaryApprover') {
    <div class="w-full h-[1px] bg-surface-200"></div>
    <div class="flex gap-10 pt-4">
      <div class="flex flex-col gap-4">
        <p-button [severity]="'primary'" styleClass="w-64" (onClick)="confirmApproveTaAcquittal('approve')">
          <i class="pi pi-check-circle pl-[1px]"></i>
          <span class="flex-1">Approve TA Acquittal</span>
        </p-button>
        <div class="bg-white rounded-lg">
          <p-button [severity]="'secondary'" outlined styleClass="w-64" (onClick)="confirmApproveTaAcquittal('withhold')">
            <i class="pi pi-exclamation-circle pl-[1px]"></i>
            <span class="flex-1">Withhold TA Acquittal Approval</span>
          </p-button>
        </div>
      </div>
      <div class="h-min-full w-[1px] bg-surface-200"></div>
      <div class="flex flex-col gap-2 flex-1">
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">If acquittal approval is withheld and changes are required, please add comments below:</div>
        <textarea pTextarea [(ngModel)]="acquittalApprovalNotes" placeholder="Click here to add comments explaining why the TA acquittal cannot be approved. The TA acquitter will receive your feedback." rows="3" pSize="small" [autoResize]="true" class="lg:w-2/3 w-full"></textarea>
      </div>
    </div>
    @if (isPrePaid()){
      @if (!isPrepaymentProcessed() && canProcessPrepayment()) {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          This TA requires prepayment processing.
        </div>
        <div class="flex flex-col gap-4">
          <p-button [severity]="'primary'" styleClass="w-64 hover:cursor" (onClick)="confirmProcessPrepayment()">
            <i class="fa-regular fa-layer-group pl-[1px]"></i>
            <span class="flex-1">Prepayment Processed</span>
          </p-button>
        </div>
      } @else if (!isPrepaymentProcessed()) {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          Awaiting prepayment processing by Finance Unit.
        </div>
      }
      @if (canCancelPrepayment()) {
        <div class="flex flex-col gap-4">
          <p-button [severity]="'danger'" data-testId="cancel-prepayment-btn" styleClass="w-64 hover:cursor" (onClick)="confirmCancelPrepayment(isPrepaymentProcessed())">
            <i class="fa-regular fa-ban pl-[1px]"></i>
            <span class="flex-1">Cancel Prepayment</span>
          </p-button>
        </div>
      }
    }
  }
</div>
